// extracted by mini-css-extract-plugin
module.exports = {"preloader":"LoaderComponent_preloader__1Fvvi","animate-preloader":"LoaderComponent_animate-preloader__9tiyR"};